import { CustomRequestStatus, customRequestStatusNames } from "@/entities/CustomRequestStatus";

export function getStatusName (statusId: CustomRequestStatus): string {
  return Object
    .entries(customRequestStatusNames)
    .filter(([id]) => {
        return id == statusId;
      })[0][1];
}

export function getSelectedStatusDropdownOption (statusId: CustomRequestStatus): string[] {
  return Object
  .entries(customRequestStatusNames)
  .filter(([id]) => {
      return id == statusId;
    })
  .map(([id]) => id);
}

